import React, { useState } from 'react';

const Sidebar = ({
  config,
  selectedModel,
  selectedCategory,
  selectedPage,
  onSelectModel,
  onSelectPage,
  onShowPricingTable,
  style,
}) => {
  const [expandedCategories, setExpandedCategories] = useState(
    config.categories.map((c) => c.id)
  );
  const [expandedVendors, setExpandedVendors] = useState({});
  const [expandedModels, setExpandedModels] = useState({});

  const toggleCategory = (categoryId) => {
    const isExpanding = !expandedCategories.includes(categoryId);

    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );

    // 如果是展开操作，自动展开该分类下的所有厂商和模型
    if (isExpanding) {
      const category = config.categories.find((c) => c.id === categoryId);
      if (category && category.vendors) {
        const newExpandedVendors = {};
        const newExpandedModels = {};

        category.vendors.forEach((vendor) => {
          const vendorKey = `${categoryId}-${vendor.id}`;
          newExpandedVendors[vendorKey] = true;

          // 展开该厂商下所有有pages的模型
          vendor.models.forEach((model) => {
            if (model.pages && model.pages.length > 0) {
              const modelKey = `${categoryId}-${vendor.id}-${model.id}`;
              newExpandedModels[modelKey] = true;
            }
          });
        });

        setExpandedVendors((prev) => ({ ...prev, ...newExpandedVendors }));
        setExpandedModels((prev) => ({ ...prev, ...newExpandedModels }));
      }
    }
  };

  const toggleVendor = (categoryId, vendorId) => {
    const key = `${categoryId}-${vendorId}`;
    const isExpanding = !expandedVendors[key];

    setExpandedVendors((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    // 如果是展开操作，自动展开该厂商下所有有pages的模型
    if (isExpanding) {
      const category = config.categories.find((c) => c.id === categoryId);
      if (category && category.vendors) {
        const vendor = category.vendors.find((v) => v.id === vendorId);
        if (vendor) {
          const newExpandedModels = {};
          vendor.models.forEach((model) => {
            if (model.pages && model.pages.length > 0) {
              const modelKey = `${categoryId}-${vendorId}-${model.id}`;
              newExpandedModels[modelKey] = true;
            }
          });
          setExpandedModels((prev) => ({ ...prev, ...newExpandedModels }));
        }
      }
    }
  };

  const toggleModel = (categoryId, vendorId, modelId) => {
    const key = `${categoryId}-${vendorId}-${modelId}`;
    setExpandedModels((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getIcon = (iconName) => {
    const icons = {
      MessageOutlined: '💬',
      PictureOutlined: '🖼️',
      VideoCameraOutlined: '🎥',
      AudioOutlined: '🎵',
      SettingOutlined: '⚙️',
      UpscaleOutlined: '🔍',
      DollarOutlined: '💰',
    };
    return icons[iconName] || '📄';
  };

  return (
    <div className='playground-sidebar' style={style}>
      <div className='sidebar-header'>
        <h1 className='sidebar-title'>智灵网关</h1>
        <p className='sidebar-subtitle'>选择模型开始测试</p>

        {/* 计费列表按钮 */}
        <button className='pricing-list-button' onClick={onShowPricingTable}>
          💰 模型广场
        </button>
      </div>
      <div className='sidebar-content'>
        {config.categories.map((category) => (
          <div key={category.id} className='sidebar-category'>
            <div
              className='category-header'
              onClick={() => toggleCategory(category.id)}
            >
              <span className='category-icon'>{getIcon(category.icon)}</span>
              <span>{category.name}</span>
            </div>
            {expandedCategories.includes(category.id) && (
              <div className='category-vendors'>
                {category.vendors &&
                  category.vendors.map((vendor) => {
                    const vendorKey = `${category.id}-${vendor.id}`;
                    return (
                      <div key={vendor.id} className='vendor-group'>
                        <div
                          className='vendor-header'
                          onClick={() => toggleVendor(category.id, vendor.id)}
                        >
                          <span className='vendor-name'>{vendor.name}</span>
                          <span className='vendor-toggle'>
                            {expandedVendors[vendorKey] ? '▼' : '▶'}
                          </span>
                        </div>
                        {expandedVendors[vendorKey] && (
                          <div className='vendor-models'>
                            {vendor.models.map((model) => {
                              const modelKey = `${category.id}-${vendor.id}-${model.id}`;
                              const isModelActive =
                                selectedModel?.id === model.id &&
                                selectedCategory?.id === category.id;

                              return (
                                <div key={model.id} className='model-group'>
                                  <div
                                    className={`model-item ${
                                      isModelActive && !selectedPage
                                        ? 'active'
                                        : ''
                                    }`}
                                    onClick={() => {
                                      onSelectModel(category, model);
                                      // 如果模型有pages，自动展开
                                      if (
                                        model.pages &&
                                        model.pages.length > 0
                                      ) {
                                        setExpandedModels((prev) => ({
                                          ...prev,
                                          [modelKey]: true,
                                        }));
                                      }
                                    }}
                                  >
                                    <div className='model-name'>
                                      {model.name}
                                      {model.tags && model.tags.length > 0 && (
                                        <span className='model-tags'>
                                          {model.tags.map((tag, idx) => (
                                            <span
                                              key={idx}
                                              className='model-tag'
                                            >
                                              {tag}
                                            </span>
                                          ))}
                                        </span>
                                      )}
                                    </div>
                                    {model.pages && model.pages.length > 0 && (
                                      <span
                                        className='model-toggle'
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleModel(
                                            category.id,
                                            vendor.id,
                                            model.id
                                          );
                                        }}
                                      >
                                        {expandedModels[modelKey] ? '▼' : '▶'}
                                      </span>
                                    )}
                                  </div>

                                  {/* 第4级：页面菜单 */}
                                  {model.pages &&
                                    model.pages.length > 0 &&
                                    expandedModels[modelKey] && (
                                      <div className='model-pages'>
                                        {model.pages.map((page) => {
                                          const isPageActive =
                                            selectedPage?.id === page.id &&
                                            selectedModel?.id === model.id;
                                          return (
                                            <div
                                              key={page.id}
                                              className={`page-item ${
                                                isPageActive ? 'active' : ''
                                              }`}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                onSelectPage(
                                                  page,
                                                  model,
                                                  category
                                                );
                                              }}
                                            >
                                              {page.name}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                {/* 兼容旧格式：如果没有vendors字段，直接显示models */}
                {!category.vendors && category.models && (
                  <div className='category-models'>
                    {category.models.map((model) => {
                      const isActive =
                        selectedModel?.id === model.id &&
                        selectedCategory?.id === category.id;
                      return (
                        <div
                          key={model.id}
                          className={`model-item ${isActive ? 'active' : ''}`}
                          onClick={() => onSelectModel(category, model)}
                        >
                          <div className='model-name'>{model.name}</div>
                          <div className='model-provider'>{model.provider}</div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
